import {
  GET_AUDIT_LOGS_REQUEST,
  GET_AUDIT_LOGS_SUCCESS,
  GET_AUDIT_LOGS_FAILURE,
  GET_AUDIT_STATS_REQUEST,
  GET_AUDIT_STATS_SUCCESS,
  GET_AUDIT_STATS_FAILURE,
  CREATE_AUDIT_LOG_REQUEST,
  CREATE_AUDIT_LOG_SUCCESS,
  CREATE_AUDIT_LOG_FAILURE,
} from '../actions/audit';

const initialState = {
  logs: [],
  pagination: {
    page: 1,
    limit: 50,
    total: 0,
    totalPages: 0,
  },
  stats: {
    total_logs: 0,
    logs_today: 0,
    logs_this_week: 0,
    logs_this_month: 0,
    top_actions: [],
    top_users: [],
    logs_by_entity: [],
  },
  loading: false,
  statsLoading: false,
  error: null,
};

export default function auditReducer(state = initialState, action) {
  switch (action.type) {
    case GET_AUDIT_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        logs: action.payload?.logs || action.payload || [],
        pagination: action.payload?.pagination || state.pagination,
        error: null,
      };

    case GET_AUDIT_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_AUDIT_STATS_REQUEST:
      return {
        ...state,
        statsLoading: true,
        error: null,
      };

    case GET_AUDIT_STATS_SUCCESS:
      return {
        ...state,
        statsLoading: false,
        stats: action.payload || state.stats,
        error: null,
      };

    case GET_AUDIT_STATS_FAILURE:
      return {
        ...state,
        statsLoading: false,
        error: action.payload,
      };

    case CREATE_AUDIT_LOG_REQUEST:
      return {
        ...state,
        error: null,
      };

    case CREATE_AUDIT_LOG_SUCCESS:
      return {
        ...state,
        error: null,
      };

    case CREATE_AUDIT_LOG_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
}
